import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import { Paper, Box, Typography, useTheme, Chip } from '@mui/material';
import { IconButton } from '@mui/material';

import { ConflictCard } from './ConflictCard';
import { ReplaceConflictWithAnnotationCard } from './ReplaceConflictWithAnnotationCard';
import { useConflictConceptCard } from './useConflictConceptCard';
import { AnnotationReview } from '../../../../types/response';

interface ConflictConceptCardProps {
  conflictInConcept: AnnotationReview;
}

export const ConflictConceptCard = ({ conflictInConcept }: ConflictConceptCardProps) => {
  const theme = useTheme();
  const { isExpanded, handleSetIsExpanded, conflictIdsInReplaceMode } = useConflictConceptCard({
    conceptId: conflictInConcept.conceptId,
  });
  return (
    <Paper
      elevation={2}
      sx={{
        borderRadius: 0,
        paddingX: theme.spacing(4),
        paddingY: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        border: `1px solid ${theme.palette.grey[300]}`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography variant="body1">{conflictInConcept.conceptName}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          <Chip
            variant="filled"
            sx={{
              backgroundColor: theme.palette.error.main,
              size: 'small',
              fontSize: '13px',
              height: '18px',
              color: theme.palette.white.main,
            }}
            label={conflictInConcept.conflicts.length}
          />

          {isExpanded ? (
            <IconButton onClick={() => handleSetIsExpanded(false)}>
              <KeyboardArrowUp />
            </IconButton>
          ) : (
            <IconButton onClick={() => handleSetIsExpanded(true)}>
              <KeyboardArrowDown />
            </IconButton>
          )}
        </Box>
      </Box>

      {isExpanded && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(3) }}>
          {conflictInConcept.conflicts.map((conflict) =>
            conflictIdsInReplaceMode.some((entry) => entry.conflictId === conflict.conflictId) ? (
              <ReplaceConflictWithAnnotationCard
                key={conflict.conflictId}
                conceptId={conflictInConcept.conceptId}
                conflictId={conflict.conflictId}
              />
            ) : (
              <ConflictCard
                key={conflict.conflictId}
                conflict={conflict}
                conceptId={conflictInConcept.conceptId}
              />
            )
          )}
        </Box>
      )}
    </Paper>
  );
};
